import { render, staticRenderFns } from "./ArrearsAlarmSetting.vue?vue&type=template&id=5adbb81e&scoped=true&"
import script from "./ArrearsAlarmSetting.vue?vue&type=script&lang=js&"
export * from "./ArrearsAlarmSetting.vue?vue&type=script&lang=js&"
import style0 from "./ArrearsAlarmSetting.vue?vue&type=style&index=0&id=5adbb81e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adbb81e",
  null
  
)

export default component.exports